var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchaseHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 5.49753C10.0051 8.28264 7.75846 10.56 5.00362 10.562C3.81381 10.5629 2.7209 10.1435 1.86205 9.44276C1.63873 9.26054 1.62203 8.92217 1.82498 8.71699L2.05214 8.48734C2.2257 8.31186 2.5028 8.29266 2.6951 8.4469C3.32786 8.95453 4.12865 9.25753 5 9.25753C7.0505 9.25753 8.70967 7.57979 8.70967 5.50709C8.70967 3.43405 7.05017 1.75665 5 1.75665C4.01584 1.75665 3.12199 2.14329 2.4583 2.7744L3.48157 3.80891C3.6848 4.01437 3.54086 4.36565 3.25348 4.36565H0.32258C0.144415 4.36565 0 4.21965 0 4.03952V1.07641C0 0.785876 0.347459 0.640363 0.550685 0.845802L1.54609 1.85214C2.44373 0.984874 3.66032 0.452148 5 0.452148C7.75826 0.452148 9.99489 2.71016 9.99999 5.49753ZM5.64516 7.42215V6.99675C5.64516 6.99675 5.64516 6.99675 5.64516 6.68511V5.5142V3.38727C5.64516 3.1171 5.42852 2.89809 5.16129 2.89809H4.83871C4.57147 2.89809 4.35484 3.1171 4.35484 3.38727V6.15222V7.42215C4.56578 7.588 5.48108 7.63541 5.64516 7.42215Z",
    fill: "url(#paint0_linear_773_10071)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_773_10071",
    x1: 5,
    y1: 0.452148,
    x2: 5,
    y2: 10.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A52626"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseHistory);
export default __webpack_public_path__ + "static/media/purchase_history.6c4c1e3857aac4f9b3412cda3c3c5078.svg";
export { ForwardRef as ReactComponent };